<div class="subBlockContent" id="confirmAMPProduct">
  <child-header [title]="'Confirm Products'" (closeEvent)="close()"></child-header>
  <loading-screen *ngIf="!loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
    (currentLoadingStatus)="onLoading($event)">
  </loading-screen>

  <div class="inner-subBlock-wrapper child-body">

    <div class="pannel-outter-wrapper">
      <!-- Subscription -->
      <ng-container>

        <div class="wrapper center-block panel-wrapper-margin">
          <div class="panel-group" id="accordionSubscription" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingSubscription">
                <div id="collapseSubscription" class="panel-collapse collapse in show" role="tabpanel"
                  aria-labelledby="headingSubscription">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="inner-subBlock-content">
                        <div>
                          <div class="mTable">
                            <table class="table display-block">
                              <thead style="width: 100%; display: inline-table;">
                                <tr>
                                  <th scope="col" class="pending-description-col" style="width: 35%">DESCRIPTION</th>
                                  <th scope="col" class="align-center" style="width: 8%">QTY</th>
                                  <th scope="col" class="align-right" style="width: 18%">UNIT RRP</th>
                                  <th scope="col" class="align-right" style="width: 18%">UNIT PRICE</th>
                                  <th scope="col" class="align-right" style="width: 16%">TOTAL</th>
                                  <!-- <th scope="col" style="width: 5%"></th> -->
                                </tr>
                              </thead>
                              <tbody style="width: 100%; display: inline-table;"> 
                                <ng-container *ngFor="let pendingItem of subscriptionItemsPendingList;index as i">
                                  <tr class="pending-grey-row">
                                    <!-- DESC -->
                                    <td style="padding-left: 50px; width: 35%" class="position-relative">
                                      <div class="description">
                                        {{pendingItem?.description}}
                                      </div>
                                      <div class="result-info">
                                        <div class="produc-secondary-title-wrapper pt-2">
                                          <span>STOCK CODE:&nbsp;</span>
                                          <span class="red-bold">{{ (pendingItem?.previewStockCode && !createScheduled) ? pendingItem?.previewStockCode : pendingItem?.stockCode }}</span>
                                        </div>
                                      </div>
                                    </td>
                                    <!-- QTY -->
                                    <td class="align-center" style="width: 8%">
                                      {{pendingItem?.quantity | number: '1.0-0'}}
                                    </td>
                                    <!-- UNIT RRP -->
                                    <td class="align-right" style="width: 18%">
                                      <div>
                                        <span>{{ (pendingItem?.previewRRP && !createScheduled) ? pendingItem?.previewRRP : pendingItem?.itemRRPrice }}</span>
                                      </div>
                                      <div *ngIf="pendingItem?.showProratedPrice && !createScheduled">
                                        <span>Prorated:&nbsp;&nbsp;{{pendingItem?.proratedRRP | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                      </div>
                                    </td>
                                    <!-- unit price -->
                                    <td class="align-right" style="width: 18%">
                                      <div>
                                        <span>{{ (pendingItem?.previewPrice && !createScheduled) ? pendingItem?.previewPrice : pendingItem?.itemPrice }}</span>
                                      </div>
                                      <div *ngIf="pendingItem?.showProratedPrice && !createScheduled">
                                        <span>{{ pendingItem?.proratedPrice | currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                      </div>
                                    </td>
                                    <!-- Total -->
                                    <td class="align-right" style="width: 16%">
                                      <div>
                                        <span *ngIf="pendingItem?.showProratedPrice && !createScheduled;else showOther">
                                          &nbsp;
                                        </span>
                                        <ng-template #showOther>
                                          <span>
                                            {{ pendingItem?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2' }}
                                          </span>
                                        </ng-template>
                                      </div>
                                      <div *ngIf="pendingItem?.showProratedPrice && !createScheduled">
                                        <span>{{ pendingItem?.proratedTotal| currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                      </div>
                                    </td>
                                    <!-- delete icon -->
                                    <!-- <td class="align-center vertical-align-mid">
                                      <span id="delete-icon" class="basic-icon delete-icon"
                                        (click)="removeSubscriptionPendingItem(i)" ngbTooltip="Remove"
                                        placement="bottom">
                                      </span>
                                    </td> -->
                                  </tr>
                                </ng-container>
                              </tbody>
                              <tfoot>
                                <div class="row totalPrice-wrapper">
                                  <div class="col align-center" *ngIf=" pendingTotal !=0 ">
                                    <span><b>Pending Total (Ex GST) </b>
                                      <span class="pendingTotal ">{{totalPriceChange |
                                        currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                                  </div>
                                  <div class="col align-center " *ngIf="pendingTotal==0 ">
                                    <span>
                                      <b>Pending Total (Ex GST)</b>
                                      <span class="pendingTotal ">
                                        {{ 0 | currency:'AUD':'symbol-narrow':'.2-2'}}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </tfoot>
                            </table>
                          </div>
                          <div style="padding-top: 75px; margin: 0px 50px;">
                            <mat-checkbox *ngIf="showCreateScheduled()" [(ngModel)]="createScheduled" (change)="changeCreateScheduled()">
                              Create this order at Anniversary Date
                            </mat-checkbox>
                            <div *ngIf="createScheduled">
                              <span class="red-bold">
                                Discount level and pricing will be calculated and applied at anniversary date with the Renewal order.
                              </span>
                            </div>
                          </div>
                          <div class="row ">
                            <div class="col button-center ">
                              <button
                                class="button button-red button-large button-center-right"
                                (click)="downloadExcelAbobeConfirmProducts('Indicative Pricing_'+ details?.customer.customer_id , details?.customer)"
                              >
                                Download Quotes
                              </button>
                            </div>
                            <div class="col button-center " *ngIf="!isQuoteCustomer">
                              <button 
                                class="button button-red button-large button-center-right"
                                [disabled]="!authService?.currentUserHasPurchaseAccess()"
                                [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
                                matTooltip="Requires Purchasing Permissions"
                                (click)="confirmSubscription()"
                              >
                                Place Order
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </div>

  </div>
</div>